import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Whitepapers } from "../data/blogData";
import { FaArrowLeft } from "react-icons/fa";
import Footer from "./Footer";
import { motion } from "framer-motion";

const DetailWhitepaper = () => {
  // 🔹 Animation
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  const { id } = useParams();
  const navigate = useNavigate();

  const whitepaper = Whitepapers.find(
    (item) => item.id === parseInt(id)
  );

  if (!whitepaper) {
    return (
      <div className="p-10 text-center text-xl">
        Whitepaper not found
      </div>
    );
  }

  // 🔥 Back Handler
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/whitepaper");
    }
  };

  return (
    <div className="bg-white">
      {/* ================= HERO ================= */}
      <section
        className="
          relative flex items-center justify-center
          py-12 sm:py-12 lg:py-16
          min-h-[350px] w-full overflow-hidden
          bg-[linear-gradient(-45deg,#101030,#0F1242,#2558BA,#306BCA)]
          bg-[length:400%_400%]
          animate-gradientFlow
        "
      >
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          className="relative z-10 w-full max-w-[1400px] px-4 sm:px-6 lg:px-8 flex justify-center"
        >
          <div className="max-w-5xl text-center">
            
            <h1 className="text-[clamp(24px,3vw,40px)] leading-tight text-white">
              {whitepaper.title}
            </h1>

            
          </div>
        </motion.div>
      </section>

      {/* ================= CONTENT ================= */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">

          {/* Back Button */}
          <button
            onClick={handleBack}
            className="flex items-center gap-2 text-gray-700 hover:text-black mb-10 transition"
          >
            <FaArrowLeft />
            Back
          </button>

          {/* Executive Summary */}
          {whitepaper.executiveSummary && (
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="mb-14"
            >
              <h2 className="text-2xl sm:text-3xl text-[#101030] mb-6">
                Executive Summary
              </h2>

              <div className="space-y-5">
                {whitepaper.executiveSummary
                  .trim()
                  .split("\n")
                  .filter((line) => line.trim() !== "")
                  .map((line, index) => (
                    <p
                      key={index}
                      className="text-gray-700 text-lg leading-relaxed"
                    >
                      {line}
                    </p>
                  ))}
              </div>
            </motion.div>
          )}

          {/* Sections */}
          <div className="space-y-16">
            {whitepaper.sections?.map((section, idx) => (
              <motion.div
                key={idx}
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                className="border-b border-gray-200 pb-12 last:border-none"
              >
                <h2 className="text-2xl sm:text-3xl text-[#101030] mb-6 leading-tight">
                  {section.heading}
                </h2>

                <div className="space-y-5">
                  {section.content
                    .trim()
                    .split("\n")
                    .filter((line) => line.trim() !== "")
                    .map((line, index) => {
                      const isBullet = line.trim().startsWith("•");

                      return isBullet ? (
                        <div
                          key={index}
                          className="flex items-start gap-3"
                        >
                          <span className="text-[#2558BA] mt-1">•</span>

                          <p className="text-gray-700 text-lg leading-relaxed">
                            {line.replace("•", "").trim()}
                          </p>
                        </div>
                      ) : (
                        <p
                          key={index}
                          className="text-gray-700 text-lg leading-relaxed"
                        >
                          {line}
                        </p>
                      );
                    })}
                </div>
              </motion.div>
            ))}
          </div>

          {/* CTA */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="mt-20 rounded-3xl bg-[#101030] p-8 sm:p-12 text-center"
          >
            <h3 className="text-3xl text-white mb-4">
              Ready to Modernize Enterprise Intelligence?
            </h3>

            <p className="text-gray-300 text-lg leading-relaxed max-w-3xl mx-auto mb-8">
              Discover how Axtelica helps enterprises build scalable AI,
              intelligent automation, and real-time decision intelligence
              platforms.
            </p>

            <button
              onClick={() => navigate("/contact")}
              className="bg-[#2558BA] hover:bg-[#1f4ca3] text-white px-8 py-4 rounded-xl transition duration-300"
            >
              Contact Us
            </button>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DetailWhitepaper;